var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-card md-card-global-sales"},[_c('div',{staticClass:"md-card-header md-card-header-icon",class:_vm.getClass(_vm.headerColor)},[_vm._t("header")],2),_c('div',{staticClass:"md-card-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }